export const UserTypes = {
    GUEST: "Guest",
    AGENCY: "Agency",
    PROVIDER: "Provider",
    ADMINISTRATOR: "Administrator"
}